import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    modalTitle: {
      fontWeight: 'bold',
      marginBottom: 20,
      fontSize: 16,
      textAlign: 'center'
    },
    modalFooter: {
      //モーダル下部
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      paddingBottom: 24,
      paddingTop: 13
    },
    button: {
      '@media screen and (min-width:600px)': {
        width: 200
      },
      '@media screen and (max-width:600px)': {
        width: 120
      },
      height: 48,
      borderRadius: 3,
      margin: 10
    },
    adjustButton: {
      '@media screen and (min-width:600px)': {
        width: 180
      },
      '@media screen and (max-width:600px)': {
        width: 90
      },
      height: 48,
      borderRadius: 3,
      margin: 10,
      '& .MuiButton-label': {
        whiteSpace: 'nowrap'
      }
    },
    subDeleteButton: {
      '@media screen and (min-width:600px)': {
        width: 100
      },
      '@media screen and (max-width:600px)': {
        width: 50
      },
      backgroundColor: '#fff',
      color: '#666666',
      border: '1px solid #A3A3A3',
      height: 48,
      borderRadius: 3,
      margin: 10,
      '& .MuiButton-label': {
        whiteSpace: 'nowrap'
      }
    },
    closeIcon: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
      float: 'right'
    }
  });
});
